import { FC, FormEvent, useEffect, useMemo, useState } from "react";
import {
  AccrualSubtractItemModel,
  HasFormIdModel,
  ActionTypeEnum,
  EmployeeEstihkakSubtractResponseModel,
} from "../../models";
import {
  checkActionPrivilege,
  getLabelName,
  isArabicCurrentLanguage,
} from "../../utils";
import { TableColumn } from "react-data-table-component";
import { ButtonBox, GridTable, TextBox } from "..";

interface DueSubtractRulesListProps extends HasFormIdModel {
  request: AccrualSubtractItemModel[];
  onActionEvent?: any | null;
  onCompleteEvent?: any | null;
}

export const DueSubtractRulesList: FC<DueSubtractRulesListProps> = ({
  request,
  onActionEvent,
  formId,
}) => {
  const isArabic = isArabicCurrentLanguage();
  const [search,setSearch] = useState<string>("");
  const [accrualSubtractItems,setAccrualSubtractItems] = useState<AccrualSubtractItemModel[]>(request);


  const handleSearch = () => {
    if(!search){
      setAccrualSubtractItems(request);
    }else{
      setAccrualSubtractItems(
        request.filter((item) =>
          item.Name.toLowerCase().includes(search.toLowerCase()) ||
        item.Name_En.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  };

  useEffect(() => {
    setAccrualSubtractItems(request);
  }, [request]);
  //#region state
  const columns: TableColumn<EmployeeEstihkakSubtractResponseModel>[] = useMemo(
    () => [
      {
        name: "#",
        selector: (_row, index) => Number(index || 0) + 1,
        sortable: true,
        width: "100px",
      },

      {
        name: getLabelName("Name"),
        selector: (row) => row.Name,
        sortable: true,
        wrap: true,
        allowOverflow: true,
      },
      {
        name: getLabelName("Name English"),
        selector: (row) => row.Name_En,
        sortable: true,
        wrap: true,
        allowOverflow: true,
      },
      {
        name: getLabelName("Notes"),
        selector: (row) => row.Notes,
        sortable: true,
        allowOverflow: true,
      },

      {
        button: true,
        // eslint-disable-next-line react/button-has-type
        cell: (row: any) =>
          checkActionPrivilege({ action: "EnableUpdate", formId: formId }) && (
            <ButtonBox
              iconType="pencil-box"
              className="btn btn-primary btn-xs"
              onClick={() => {
                onActionEvent({
                  id: row.ID,
                  request: row,
                  action: ActionTypeEnum.Update,
                });
              }}
            >
              {getLabelName("Edit")}
            </ButtonBox>
          ),
      },
      {
        button: true,
        // eslint-disable-next-line react/button-has-type
        cell: (row: any) =>
          checkActionPrivilege({ action: "EnableDelete", formId: formId }) && (
            <ButtonBox
              iconType="delete"
              className="btn btn-danger btn-xs"
              onClick={() => {
                onActionEvent({
                  id: row.ID,
                  request: row,
                  action: ActionTypeEnum.Delete,
                });
              }}
            >
              {getLabelName("Delete")}
            </ButtonBox>
          ),
      },
    ],
    []
  );
  //#endregion
  //#region html
  return (
    <>
<div
  className="d-flex  gap-2 mb-4 justify-content-between align-items-center"
  style={{ maxWidth: "100%", width: "100%" }}
>
<div style={{ flex: "1 1 auto", minWidth: "150px" }}>
        <TextBox
            inputName="search"
            inputValue={search}
            onChange={(e: FormEvent<HTMLInputElement>) =>
              setSearch(e.currentTarget.value)
            }
            labelName=""
            placeHolder={`${getLabelName("name")}`}
            controlSize="w-10"
        />
        </div>
        <ButtonBox onClick={handleSearch}>
            {getLabelName("search")}
        </ButtonBox>
      </div>
      <GridTable
        //columns={columns}
        data={accrualSubtractItems}
        totalRows={accrualSubtractItems.length}
        currentPage={1}
        pageSize={50}
        formId={formId}
        columnsProps={{
            actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
            isArabic: isArabic,
            onActionEvent,
        }}
      />
    </>
  );
  //#endregion
};
